module.exports = __webpack_public_path__ + "img/Postmodernisme_Litteraturen42.52ce05fc.jpg";